import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ContentShare } from '@ifeng/ui_pc_share';
import errorBoundary from '@ifeng/errorBoundary';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            allowComment,
            joinNum,
            count,
            noffhFlag,
            title,
            dateTime,
            fhhAccountDetail,
            author,
            searchPath,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            followUrl,
        } = content;

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const props =
            !fhhAccountDetail.forbidJump && fhhAccountDetail.authorUrl
                ? {
                      href: fhhAccountDetail.authorUrl,
                      target: '_blank',
                  }
                : {};

        return (
            <div>
                <h1 className={styles.topic}>{title}</h1>
                <div className={styles.info}>
                    <p className={styles.time}>
                        <span className={styles.date}>{dateTime}</span>
                        <br />
                        <span style={{ verticalAlign: 'bottom' }}>{fhhAccountDetail.catename ? '来源：' : ''}</span>
                        <span className={styles.publisher}>
                            {!fhhAccountDetail.catename ? (
                                <span className={styles.source}>
                                    {fhhAccountDetail.authorUrl ? (
                                        <a href={fhhAccountDetail.authorUrl} target="_blank">
                                            {fhhAccountDetail.catename}
                                        </a>
                                    ) : (
                                        <span className={styles.txt}>{fhhAccountDetail.catename}</span>
                                    )}
                                </span>
                            ) : (
                                <span className={styles.source}>
                                    {noffhFlag ? (
                                        <a>{fhhAccountDetail.catename}</a>
                                    ) : (
                                        <a {...props}>{fhhAccountDetail.catename}</a>
                                    )}
                                </span>
                            )}
                        </span>
                        <span style={{ verticalAlign: 'bottom' }}>
                            {searchPath && searchPath.indexOf('275799-') === 0 && author && `  作者：${author}`}
                        </span>
                    </p>
                    <div className={styles.share_box}>
                        <ContentShare shareInfo={shareInfo} />
                    </div>
                    {allowComment ? (
                        <div className={styles.comment_box}>
                            <h5 className={styles.comment}>
                                <a className={styles.joinNum} href={followUrl} target="_blank">
                                    <span className={styles.num}>{joinNum}</span>
                                    <span className={styles.text}>人参与</span>
                                </a>
                                <a className={styles.commentNum} href={followUrl} target="_blank">
                                    <span className={styles.num}>{count}</span>
                                    <span className={styles.text}>评论</span>
                                </a>
                            </h5>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className={styles.devide} />
            </div>
        );
    }
}

export default errorBoundary(Caption);
